import {venderEntradas} from '../../utils/eventosService';
import {catalogoComercial} from '../../utils/comercialEvento';
import { obtenerRelacionadoresEvento } from '../../utils/relacionadores';
import { useAuth } from '../../context/AuthContext';
import { resolverAtribucion, etiquetaRelacionador } from '../../utils/identidadOperativa';
// src/pages/entradas/GenerarEntradas.jsx
import React, { useEffect, useMemo, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { db } from "../../firebase/firebaseConfig";
import { doc } from 'firebase/firestore';
import { getDoc } from '../../utils/firestoreRead';
import VistaEntrada from "./VistaEntrada";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import html2canvas from "html2canvas";
import { verificarAccesoEvento } from "../../utils/eventAccess";
import "./GenerarEntradas.css";

const PRECIO_ENTRADA = 80;
const PRECIO_PAQUETE = 700;
const ENTRADAS_POR_PAQUETE = 10;

export default function GenerarEntradas() {
  const {profile,usuario,user}=useAuth();
  const compraPropia=['imagen','rrpp'].includes(profile?.rol||usuario?.rol);
  const { eventoId } = useParams();
  const navigate = useNavigate();

  const [evento, setEvento] = useState(null);
  const solicitudVenta=useRef(null);
  const canalVenta = 'sistema';
  const [relojComercial,setRelojComercial]=useState(Date.now());
  useEffect(()=>{const timer=setInterval(()=>setRelojComercial(Date.now()),15000);return()=>clearInterval(timer);},[]);
  const [relacionadores, setRelacionadores] = useState([]);
  const [atribuidoAUid, setAtribuidoAUid] = useState('');
  useEffect(() => {
    let alive = true;
    if (evento&&!compraPropia) obtenerRelacionadoresEvento(evento, 'entradas').then((lista) => { if (alive) setRelacionadores(lista); }).catch(() => { if (alive) setRelacionadores([]); });
    return () => { alive = false; };
  }, [evento,compraPropia]);
  const [cargandoEvento, setCargandoEvento] = useState(true);
  const [comprador, setComprador] = useState("");
  const [cantidades, setCantidades] = useState({});
  const [items, setItems] = useState([]);
  const [revisandoCompra,setRevisandoCompra]=useState(false);
  useEffect(()=>{if(!revisandoCompra)return;const previo=document.body.style.overflow;document.body.style.overflow='hidden';return()=>{document.body.style.overflow=previo;};},[revisandoCompra]);
  const [generando, setGenerando] = useState(false);

  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const check = () => {
      if (typeof window !== "undefined") {
        setIsMobile(window.innerWidth <= 768);
      }
    };
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  // Cargar y validar SOLO el evento de la URL.
  // La seguridad de roles no debe depender de las entradas, sino del evento.
  useEffect(() => {
    const cargar = async () => {
      try {
        const acceso = await verificarAccesoEvento(eventoId, "entradas");
        if (!acceso.permitido) {
          alert("No tienes acceso a este evento.");
          navigate("/entradas");
          return;
        }

        const ref = doc(db, "eventos", eventoId);
        const snap = await getDoc(ref);
        if (!snap.exists()) {
          alert("El evento no existe.");
          navigate("/entradas");
          return;
        }

        const data = { id: snap.id, ...snap.data() };
        if (!data.empresaId) {
          alert("Este evento no tiene empresa asignada. Elimínalo o recréalo correctamente antes de generar entradas.");
          navigate("/entradas");
          return;
        }

        setEvento(data);
      } catch (e) {
        console.error("Error cargando evento para entradas", e);
        alert("Error cargando el evento.");
        navigate("/entradas");
      } finally {
        setCargandoEvento(false);
      }
    };
    cargar();
  }, [eventoId, navigate]);

  const combos = useMemo(() => {
    if (!evento) return [];

    if (Array.isArray(evento.combos) && evento.combos.length > 0) {
      return catalogoComercial(evento,[],relojComercial,canalVenta).evento.combos.map((c, idx) => ({
        id: c.id || `combo-${idx}`,
        nombre: c.nombre || `Combo ${idx + 1}`,
        descripcion: c.descripcion || "",
        precioCentavos: typeof c.precioCentavos === "number" ? c.precioCentavos : 0,
        cantidadEntradas: typeof c.cantidadEntradas === "number" ? c.cantidadEntradas : 1,
      }));
    }

    if(evento.comercialConfig?.schemaVersion===2)return [];
    // combos por defecto si el evento no tiene
    return [
      {
        id: "entrada-individual",
        nombre: "Entrada individual",
        descripcion: "1 entrada",
        precioCentavos: PRECIO_ENTRADA * 100,
        cantidadEntradas: 1,
      },
      {
        id: "paquete-completo",
        nombre: "Paquete de 10 entradas",
        descripcion: `${ENTRADAS_POR_PAQUETE} entradas`,
        precioCentavos: PRECIO_PAQUETE * 100,
        cantidadEntradas: ENTRADAS_POR_PAQUETE,
      },
    ];
  }, [evento,relojComercial]);

  const totalEntradas = useMemo(
    () =>
      combos.reduce(
        (sum, c) => sum + (cantidades[c.id] || 0) * c.cantidadEntradas,
        0
      ),
    [combos, cantidades]
  );

  const totalCentavos = useMemo(
    () =>
      combos.reduce(
        (sum, c) => sum + (cantidades[c.id] || 0) * c.precioCentavos,
        0
      ),
    [combos, cantidades]
  );

  const tieneSelecciones = useMemo(
    () => Object.values(cantidades).some((v) => v > 0),
    [cantidades]
  );

  const entradasYaGeneradas = items.length > 0;

  const handleNuevaGeneracion = (event) => {
    // En iPhone/Safari algunos botones pueden sentirse "congelados" si abren
    // confirmaciones del navegador después de generar/compartir archivos.
    // Por eso la nueva venta reinicia directo el formulario y la vista previa.
    event?.preventDefault?.();
    event?.stopPropagation?.();

    setItems([]);
    setRevisandoCompra(false);
    setCantidades({});
    setComprador("");
    setAtribuidoAUid('');

    if (typeof window !== "undefined") {
      window.setTimeout(() => {
        const input = document.querySelector("input[placeholder='Ej: Juan Pérez']");
        if (input) input.focus({ preventScroll: true });
      }, 50);
    }
  };

  const handleCambiarCantidad = (comboId, delta) => {
    if (entradasYaGeneradas || generando) return;
    setCantidades((prev) => {
      const actual = prev[comboId] || 0;
      const nuevo = actual + delta;
      if (nuevo < 0) return prev;
      return { ...prev, [comboId]: nuevo };
    });
  };

const generarEntradasEnFirestore = async () => {
  if (generando || entradasYaGeneradas) return;
  if (!evento || !tieneSelecciones || !comprador.trim()) return;

  setGenerando(true);
  try {
    const atribucion = compraPropia?{atribuidoAUid:user?.uid||usuario?.uid}:resolverAtribucion(await obtenerRelacionadoresEvento(evento, 'entradas'), atribuidoAUid, evento, 'entradas');
    const payload={canal:canalVenta,eventoId:evento.id,comprador:comprador.trim(),atribuidoAUid:atribucion.atribuidoAUid||null,carrito:cantidades,importeEsperadoCentavos:totalCentavos};
    const key=JSON.stringify(payload);if(solicitudVenta.current?.key!==key)solicitudVenta.current={key,id:window.crypto?.randomUUID?.()||('venta-'+Date.now()+'-'+Math.random().toString(36).slice(2))};
    const result=await venderEntradas({...payload,solicitudId:solicitudVenta.current.id});
    const nuevas=result.items;solicitudVenta.current=null;
    setItems(nuevas);
    setRevisandoCompra(false);
  } catch (e) {
    console.error("Error generando entradas", e);
    alert(e.message || 'No se pudo registrar la venta.');
  } finally {
    setGenerando(false);
  }
};


  // Misma lógica final de invitaciones: capturar el render maestro visible.
  // No se clona una tarjeta con medidas distintas y no se fuerza 360x640.
  const getScaleHD = () => 4;

  const esperarImagenes = async (node) => {
    const imgs = Array.from(node?.querySelectorAll?.('img') || []);
    await Promise.all(
      imgs.map((img) => {
        if (img.complete && img.naturalWidth > 0) return Promise.resolve();
        return new Promise((resolve) => {
          img.onload = resolve;
          img.onerror = resolve;
          setTimeout(resolve, 3000);
        });
      })
    );
  };

  const capturarEntrada = async (node, { scale } = {}) => {
    const renderNode = node?.querySelector?.('.palma-entrada-render') || node;
    if (!renderNode) return null;

    await esperarImagenes(renderNode);
    await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));

    const rect = renderNode.getBoundingClientRect();
    const width = Math.round(rect.width);
    const height = Math.round(rect.height);

    const canvas = await html2canvas(renderNode, {
      scale: scale || getScaleHD(),
      useCORS: true,
      allowTaint: false,
      backgroundColor: '#ffffff',
      imageTimeout: 20000,
      logging: false,
      width,
      height,
      windowWidth: Math.max(document.documentElement.clientWidth || 0, width),
      windowHeight: Math.max(document.documentElement.clientHeight || 0, height),
      scrollX: 0,
      scrollY: 0,
      onclone: (clonedDoc) => {
        const clonedRender = clonedDoc.querySelector('.palma-entrada-render');
        if (clonedRender) {
          clonedRender.style.width = `${width}px`;
          clonedRender.style.height = `${height}px`;
          clonedRender.style.maxWidth = 'none';
          clonedRender.style.transform = 'none';
          clonedRender.style.borderRadius = '0px';
          clonedRender.style.overflow = 'hidden';
          clonedRender.style.boxShadow = 'none';
        }
      },
    });

    return await new Promise((resolve) => canvas.toBlob(resolve, 'image/png', 1));
  };

  const handleGenerarZip = async () => {
    if (!items.length) return;

    try {
      const zip = new JSZip();
      const nodos = Array.from(document.querySelectorAll(".entrada-preview-capture"));
      const scaleHD = getScaleHD();

      const limit = Math.min(nodos.length, items.length);
      for (let i = 0; i < limit; i++) {
        const blob = await capturarEntrada(nodos[i], { scale: scaleHD });
        if (!blob) continue;
        zip.file(`entrada-${items[i].id}.png`, blob);
      }

      const blob = await zip.generateAsync({ type: "blob" });
      const safeName = (comprador || "")
        .trim()
        .replace(/\s+/g, "_")
        .toLowerCase();
      saveAs(blob, `entradas-${safeName || "comprador"}.zip`);
    } catch (e) {
      console.error("Error generando ZIP de entradas", e);
      alert("Error generando ZIP.");
    }
  };

  const handleEnviarWhatsapp = async () => {
    if (!items.length || !evento) return;

    try {
      const nodos = Array.from(document.querySelectorAll(".entrada-preview-capture"));
      if (!nodos.length) {
        alert("Primero genera la vista previa de las entradas.");
        return;
      }

      const scaleHD = getScaleHD();
      const files = [];
      const limit = Math.min(nodos.length, items.length);

      for (let i = 0; i < limit; i++) {
        const blob = await capturarEntrada(nodos[i], { scale: scaleHD });
        if (!blob) continue;

        const nombreSeguro = String(comprador || `entrada_${i + 1}`)
          .trim()
          .replace(/\s+/g, "_")
          .toLowerCase();

        files.push(
          new File([blob], `${nombreSeguro}_${i + 1}.png`, {
            type: "image/png",
          })
        );
      }

      if (navigator.canShare && navigator.canShare({ files })) {
        await navigator.share({ files });
      } else {
        const zip = new JSZip();
        for (const f of files) zip.file(f.name, f);
        const contenidoZip = await zip.generateAsync({ type: "blob" });
        saveAs(contenidoZip, "entradas.zip");
        alert("Tu navegador no permite compartir imágenes directamente. Se descargó un ZIP con las entradas.");
      }
    } catch (e) {
      console.error("Error compartiendo entradas:", e);
      alert("No se pudieron compartir las entradas. Intenta desde un móvil compatible.");
    }
  };

  if (cargandoEvento) {
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "#020617",
          color: "#e5e7eb",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        Cargando evento...
      </div>
    );
  }

  if (!evento) {
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "#020617",
          color: "#e5e7eb",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        No se encontró el evento.
      </div>
    );
  }

  return (
    <div
      className="ge-page"
      style={{
        minHeight: "100vh",
        background: "#020617",
        color: "#e5e7eb",
        padding: isMobile ? "1rem 0.75rem 1.5rem" : "1.5rem",
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          maxWidth: 1100,
          margin: "0 auto",
          paddingBottom: "6rem",
        }}
      >
        {/* Header con info del evento */}
        <header
          style={{
            marginBottom: "1.25rem",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "0.75rem",
            flexWrap: "wrap",
          }}
        >
          <div>
            <h2 style={{ margin: 0, fontSize: 24 }}>Comprar entradas</h2>
            <p
              style={{
                margin: "0.25rem 0 0.15rem",
                fontSize: 13,
                color: "#9ca3af",
              }}
            >
              Evento:{" "}
              <span style={{ color: "#e5e7eb", fontWeight: 600 }}>
                {evento.nombre || "Sin nombre"}
              </span>{" "}
              · {evento.fechaTexto || "sin fecha"}
            </p>
            <p
              style={{
                margin: 0,
                fontSize: 12,
                color: "#6b7280",
              }}
            >
              Selecciona tus entradas y revisa el total de tu compra.
            </p>
          </div>

          <button
            type="button"
            onClick={() => navigate("/entradas")}
            style={{
              padding: "0.4rem 0.9rem",
              borderRadius: 999,
              border: "1px solid #374151",
              background: "transparent",
              color: "#e5e7eb",
              fontSize: 12,
              cursor: "pointer",
              whiteSpace: "nowrap",
            }}
          >
            Cambiar evento
          </button>
        </header>

        {/* Layout principal: comprador + resumen + combos */}
        <div className="ge-layout">
          {/* Comprador + resumen */}
          <section className="ge-customer">
            {/* Comprador */}
            <div className="ge-field">
              <label
                style={{
                  display: "block",
                  marginBottom: 4,
                  fontSize: 13,
                  fontWeight: 600,
                }}
              >
                NOMBRE DEL COMPRADOR
              </label>
              <input
                type="text"
                value={comprador}
                onChange={(e) => setComprador(e.target.value)}
                disabled={entradasYaGeneradas || generando}
                placeholder="Ej: Juan Pérez"
                style={{
                  width: "100%",
                  padding: "0.5rem 0.75rem",
                  borderRadius: 999,
                  border: "1px solid #111827",
                  background: "rgba(15,23,42,0.9)",
                  color: "#e5e7eb",
                  fontSize: 14,
                  outline: "none",
                  opacity: entradasYaGeneradas || generando ? 0.7 : 1,
                  cursor: entradasYaGeneradas || generando ? "not-allowed" : "text",
                }}
              />
            </div>

            {!compraPropia&&<label className="ge-field ge-relacionador">Relacionador (opcional)
              <select aria-label="Relacionador de entradas" value={atribuidoAUid} onChange={(e) => setAtribuidoAUid(e.target.value)} disabled={entradasYaGeneradas || generando}>
                <option value="">Sin promotor / venta directa</option>
                {relacionadores.map((p) => <option key={p.id} value={p.id}>{etiquetaRelacionador(p)}</option>)}
              </select>
            </label>}
          </section>
            {/* Resumen */}
          <section className="ge-summary" aria-label="Resumen de entradas">
              <div
                style={{
                  borderRadius: 14,
                  padding: "0.9rem 1rem",
                  background: "rgba(15,23,42,0.95)",
                  border: "1px solid #111827",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 6,
                    fontSize: 13,
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Resumen</span>
                  <span style={{ color: "#9ca3af" }}>
                    {evento.nombre || "Sin evento"}
                  </span>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 6,
                    fontSize: 13,
                  }}
                >
                  <span>Entradas</span>
                  <span style={{ fontWeight: 600 }}>
                    {totalEntradas} entrada
                    {totalEntradas !== 1 ? "s" : ""}
                  </span>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: 6,
                    fontSize: 13,
                  }}
                >
                  <span>Total</span>
                  <span style={{ fontWeight: 700 }}>
                    Bs {(totalCentavos / 100).toFixed(2)}
                  </span>
                </div>

                <div
                  style={{
                    marginTop: 8,
                    paddingTop: 8,
                    borderTop: "1px solid #111827",
                    fontSize: 11,
                    color: "#9ca3af",
                  }}
                >
                  <div>Comprador: {comprador || "-"}</div>
                  <div>Evento: {evento.fechaTexto || "sin fecha"}</div>
                </div>
              </div>
          </section>

          {/* Combos */}
          <section className="ge-combos">
            <div
              className="ge-combos-heading"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "baseline",
                marginBottom: "0.6rem",
              }}
            >
              <h3
                style={{
                  margin: 0,
                  fontSize: 15,
                  fontWeight: 600,
                }}
              >
                Combos de entradas
              </h3>
              <span
                style={{
                  fontSize: 11,
                  color: "#9ca3af",
                }}
              >
                Define cantidades por combo
              </span>
            </div>

            {combos.length === 0 ? (
              <div style={{ fontSize: 13, color: "#9ca3af" }}>
                Este evento no tiene combos configurados.
              </div>
            ) : (
              <div className="ge-combos-grid">
                {combos.map((combo) => {
                  const cantidad = cantidades[combo.id] || 0;
                  return (
                    <div
                      key={combo.id}
                      className="ge-combo-card"
                      style={{
                        borderRadius: 14,
                        padding: "0.85rem",
                        background: "rgba(15,23,42,0.95)",
                        border: "1px solid #111827",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        minHeight: 135,
                      }}
                    >
                      <div>
                        <div
                          style={{
                            fontWeight: 600,
                            marginBottom: 2,
                            fontSize: 14,
                          }}
                        >
                          {combo.nombre}
                        </div>
                        <div
                          style={{
                            fontSize: 12,
                            color: "#9ca3af",
                          }}
                        >
                          Bs {(combo.precioCentavos / 100).toFixed(2)} · {combo.cantidadEntradas} entrada
                          {combo.cantidadEntradas !== 1 ? "s" : ""}
                        </div>
                      </div>

                      <div
                        className="ge-combo-controls"
                        style={{
                          marginTop: 10,
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            display: "inline-flex",
                            borderRadius: 999,
                            border: "1px solid #374151",
                            overflow: "hidden",
                          }}
                        >
                          <button
                            type="button"
                            onClick={() =>
                              handleCambiarCantidad(combo.id, -1)
                            }
                            disabled={entradasYaGeneradas || generando}
                            style={{
                              border: "none",
                              background: "transparent",
                              color: "#e5e7eb",
                              padding: "0.2rem 0.6rem",
                              cursor: entradasYaGeneradas || generando ? "not-allowed" : "pointer",
                              opacity: entradasYaGeneradas || generando ? 0.45 : 1,
                              fontSize: 16,
                            }}
                          >
                            −
                          </button>
                          <div
                            style={{
                              minWidth: 28,
                              textAlign: "center",
                              fontSize: 14,
                              padding: "0.2rem 0.3rem",
                            }}
                          >
                            {cantidad}
                          </div>
                          <button
                            type="button"
                            onClick={() =>
                              handleCambiarCantidad(combo.id, 1)
                            }
                            disabled={entradasYaGeneradas || generando}
                            style={{
                              border: "none",
                              background: "var(--pm-accent)",
                              color: "#111827",
                              padding: "0.2rem 0.6rem",
                              cursor: entradasYaGeneradas || generando ? "not-allowed" : "pointer",
                              opacity: entradasYaGeneradas || generando ? 0.45 : 1,
                              fontSize: 16,
                            }}
                          >
                            +
                          </button>
                        </div>

                        <div
                          style={{
                            fontSize: 12,
                            textAlign: "right",
                            color: "#e5e7eb",
                          }}
                        >
                          {cantidad > 0 && (
                            <>
                              <div>
                                {cantidad * combo.cantidadEntradas} entrada
                                {cantidad * combo.cantidadEntradas !== 1 ? "s" : ""}
                              </div>
                              <div>
                                Bs {(cantidad * combo.precioCentavos / 100).toFixed(2)}
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </section>
        </div>

        {/* Vista previa */}
        {items.length > 0 && (
          <section style={{ marginTop: "1.25rem" }}>
            <h3
              style={{
                fontSize: 14,
                margin: "0 0 0.5rem",
                fontWeight: 600,
              }}
            >
              Entradas de tu compra
            </h3>
            <div
              style={{
                marginBottom: "0.75rem",
                padding: "0.7rem 0.85rem",
                borderRadius: 12,
                background: "rgba(34,197,94,0.1)",
                border: "1px solid rgba(34,197,94,0.35)",
                color: "#bbf7d0",
                fontSize: 12,
              }}
            >
              Compra confirmada. Tus entradas están listas para descargar o compartir.
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns:
                  "repeat(auto-fit, minmax(260px, 1fr))",
                gap: "1rem",
              }}
            >
              {items.map((it) => (
                <div
                  key={it.id}
                  style={{
                    width: "100%",
                    overflowX: "auto",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <div
                    className="entrada-preview-capture"
                    style={{
                      display: "inline-block",
                      width: 300,
                      margin: "0 auto",
                      borderRadius: 0,
                      overflow: "visible",
                      background: "transparent",
                      boxShadow: "none",
                      flex: "0 0 auto",
                    }}
                  >
                    <VistaEntrada
                      id={it.id}
                      evento={evento}
                      arteEntrada={evento.arteEntrada}
                      layoutEntrada={evento.layoutEntrada}
                      width={300}
                    />
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}

        {revisandoCompra&&<div className="ge-review-backdrop"><section className="ge-review" role="dialog" aria-modal="true" aria-labelledby="ge-review-title" onKeyDown={e=>{if(e.key==='Escape'&&!generando)setRevisandoCompra(false);if(e.key==='Tab'){const buttons=Array.from(e.currentTarget.querySelectorAll('button:not(:disabled)'));const first=buttons[0],last=buttons.at(-1);if(e.shiftKey&&document.activeElement===first){e.preventDefault();last?.focus();}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first?.focus();}}}}>
          <header><h2 id="ge-review-title">Revisar compra</h2></header>
          <dl><div><dt>Evento</dt><dd>{evento.nombre}</dd></div><div><dt>Cliente</dt><dd>{comprador.trim()}</dd></div></dl>
          <table><thead><tr><th>Entrada</th><th>Cantidad</th><th>Importe</th></tr></thead><tbody>{combos.filter(c=>cantidades[c.id]>0).map(c=><tr key={c.id}><td>{c.nombre}</td><td>{cantidades[c.id]}</td><td>Bs {((c.precioCentavos*cantidades[c.id])/100).toFixed(2)}</td></tr>)}</tbody></table>
          <div className="ge-review-total"><span>Total · {totalEntradas} entradas</span><strong>Bs {(totalCentavos/100).toFixed(2)}</strong></div>
          <footer><button type="button" autoFocus disabled={generando} onClick={()=>setRevisandoCompra(false)}>Volver</button><button type="button" className="ge-review-confirm" disabled={generando} onClick={generarEntradasEnFirestore}>{generando?'Confirmando compra…':'Confirmar compra'}</button></footer>
        </section></div>}

        {/* Barra inferior */}
        <div
          role="region"
          aria-label="Total de compra"
          style={{
            position: "fixed",
            left: 0,
            right: 0,
            bottom: 0,
            background:
              "linear-gradient(to top, #020617 60%, rgba(2,6,23,0.9) 100%)",
            borderTop: "1px solid #111827",
            padding: "0.6rem 1rem",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: 1100,
              display: "flex",
              flexDirection: "column",
              gap: "0.4rem",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: 12,
              }}
            >
              <div>
                <div style={{ fontWeight: 600 }}>
                  {totalEntradas} entrada
                  {totalEntradas !== 1 ? "s" : ""}
                </div>
                <div style={{ color: "#9ca3af", fontSize: 11 }}>
                  {tieneSelecciones
                    ? "Revisa tu compra"
                    : "Selecciona un combo"}
                </div>
              </div>
              <div style={{ textAlign: "right" }}>
                <div style={{ fontWeight: 700 }}>
                  Bs {(totalCentavos / 100).toFixed(2)}
                </div>
                <div style={{ fontSize: 11, color: "#9ca3af" }}>
                  Comprador: {comprador || "-"}
                </div>
              </div>
            </div>

            <div
              style={{
                display: isMobile ? "grid" : "flex",
                gridTemplateColumns: isMobile ? "1fr" : undefined,
                gap: "0.5rem",
                fontSize: 13,
              }}
            >
              <button
                type="button"
                onClick={()=>setRevisandoCompra(true)}
                disabled={
                  !evento ||
                  !tieneSelecciones ||
                  !comprador.trim() ||
                  generando ||
                  entradasYaGeneradas
                }
                style={{
                  flex: 1,
                  padding: "0.5rem 0.75rem",
                  borderRadius: 999,
                  border: "none",
                  background:
                    !evento || !tieneSelecciones || !comprador.trim() || generando || entradasYaGeneradas
                      ? "#1f2937"
                      : "var(--pm-accent)",
                  color:
                    !evento || !tieneSelecciones || !comprador.trim() || generando || entradasYaGeneradas
                      ? "#6b7280"
                      : "#0f172a",
                  fontWeight: 700,
                  cursor:
                    !evento || !tieneSelecciones || !comprador.trim() || generando || entradasYaGeneradas
                      ? "not-allowed"
                      : "pointer",
                }}
              >
                {generando
                  ? "Confirmando compra…"
                  : entradasYaGeneradas
                  ? "Compra confirmada"
                  : "Revisar compra"}
              </button>

              {items.length > 0 && (
                <>
                  <button
                    type="button"
                    onClick={handleEnviarWhatsapp}
                    style={{
                      flex: 1,
                      padding: "0.5rem 0.75rem",
                      borderRadius: 999,
                      border: "none",
                      background: "var(--pm-accent)",
                      color: "#022c22",
                      fontWeight: 700,
                      cursor: "pointer",
                    }}
                  >
                    Enviar por WhatsApp
                  </button>

                  <button
                    type="button"
                    onClick={handleGenerarZip}
                    style={{
                      flex: 1,
                      padding: "0.5rem 0.75rem",
                      borderRadius: 999,
                      border: "none",
                      background: "var(--pm-accent)",
                      color: "#111827",
                      fontWeight: 700,
                      cursor: "pointer",
                    }}
                  >
                    Descargar ZIP
                  </button>

                  <button
                    type="button"
                    onClick={handleNuevaGeneracion}
                    onTouchEnd={handleNuevaGeneracion}
                    style={{
                      flex: 1,
                      padding: "0.5rem 0.75rem",
                      borderRadius: 999,
                      border: "1px solid #475569",
                      background: "transparent",
                      color: "#e5e7eb",
                      fontWeight: 700,
                      cursor: "pointer",
                      touchAction: "manipulation",
                      WebkitTapHighlightColor: "transparent",
                    }}
                  >
                    Nueva compra
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
